var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon6(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Vector",
    x: 51.7998,
    y: 4.19995,
    width: 8.4,
    height: 47.6,
    rx: 1.4,
    transform: "rotate(90 51.7998 4.19995)",
    fill: "#6B7CFF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.2002 16.8C32.2002 16.0268 31.5734 15.4 30.8002 15.4H5.6002C4.827 15.4 4.2002 16.0268 4.2002 16.8V50.4C4.2002 51.1732 4.827 51.8 5.6002 51.8H30.8002C31.5734 51.8 32.2002 51.1732 32.2002 50.4V16.8ZM26.5998 22.4H9.79982V25.2H26.5998V22.4ZM9.79982 32.2H26.5998V35H9.79982V32.2ZM26.5998 42H9.79982V44.8H26.5998V42Z",
    fill: "#6B7CFF"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Vector_3",
    x: 35,
    y: 15.4,
    width: 16.8,
    height: 36.4,
    rx: 1.4,
    fill: "#6B7CFF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon6);
export default __webpack_public_path__ + "static/media/Icon6.80fa9d0fead9bbe1b1a3543b92b49961.svg";
export { ForwardRef as ReactComponent };